module.exports = __webpack_public_path__ + "img/流体力学1_3_3.008ca647.jpg";